import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

@Injectable()
export class NotificacaoService {
    _notificationsService: NotificationsService;

    public opcoes = {
        position: ["top", "right"],
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: true,
        clickToClose: true,
        maxLength: 100
    };

    constructor(private  notificationsService: NotificationsService) {
          this._notificationsService =  notificationsService;
    }

    public Sucesso(title, text) {
      this._notificationsService.success(
        title,
        text,
        this.opcoes
      );
    }

    public Erro(title, text) {
      this._notificationsService.error(
        title,
        text,
        this.opcoes
      );
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/notificacao.service.ts